import { useQuery } from '@tanstack/react-query';
import clientApi from '~/clientApi';
import { CREATORS_COLLECTION_QUERY_KEY } from '~/queries/keys';

export const getFetchCreatorKeyFn = (id?: string) => {
  return {
    queryKey: [CREATORS_COLLECTION_QUERY_KEY, { id }],
    queryFn: () => clientApi.creators.read({ id }),
  };
};

export const useFetchCreator = (id: string | undefined) => {
  return useQuery({
    ...getFetchCreatorKeyFn(id),
    enabled: Boolean(id),
  });
};
